<script setup>
import { computed, nextTick, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { useUISettings } from 'dashboard/composables/useUISettings';

import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
// The sidebar passes the target route name: the provider resolves gating from
// that route's meta, so anything else silently drops the feature flag.
import { SIDEBAR_ROUTES } from '../constants';

const store = useStore();
const router = useRouter();
const route = useRoute();
const { uiSettings } = useUISettings();

const inboxes = computed(() => store.getters['metaAgent/getInboxes']);

const resolveInboxId = () => {
  const { last_active_meta_agent_inbox_id: lastActiveInboxId } =
    uiSettings.value || {};

  const isPresent = inboxes.value.some(
    inbox => inbox.id === Number(lastActiveInboxId)
  );
  if (isPresent) return lastActiveInboxId;

  return inboxes.value[0]?.id;
};

const routeToInbox = () => {
  const inboxId = resolveInboxId();

  if (!inboxId) {
    return router.replace({
      name: 'meta_agent_connect_index',
      params: { accountId: route.params.accountId },
    });
  }

  const { navigationPath } = route.params;
  const target = SIDEBAR_ROUTES.includes(navigationPath)
    ? navigationPath
    : 'meta_agent_overview_index';

  return router.replace({
    name: target,
    params: { accountId: route.params.accountId, inboxId },
  });
};

onMounted(async () => {
  await store.dispatch('metaAgent/getInboxes');
  nextTick(() => routeToInbox());
});
</script>

<template>
  <div
    class="flex items-center justify-center w-full bg-n-surface-1 text-n-slate-11"
  >
    <Spinner />
  </div>
</template>
